import React from "react";
import useFrontPageCta from "../../../Hooks/useFrontPageCta";
import { FiCompass, FiMessageCircle, FiUsers } from "react-icons/fi";

// Components
import ButtonPillGradient from "../../Buttons/ButtonPillGradient";

// Constants
import { RoutePaths } from "../../../Constants/RoutePaths";

const communityFeatures = [
    {
        title: "Members' forum",
        copy:
            "Start or join conversations about Ickonic programmes, current events and the ideas around them.",
        icon: <FiUsers aria-hidden="true" focusable="false" />,
    },
    {
        title: "Conversations beneath videos",
        copy: "Comment, reply and vote while the story is still fresh.",
        icon: <FiMessageCircle aria-hidden="true" focusable="false" />,
    },
    {
        title: "Different voices, shared curiosity",
        copy: "Listen, question respectfully and make up your own mind.",
        icon: <FiCompass aria-hidden="true" focusable="false" />,
    },
];

const FrontCommunitySection: React.FC = () => {
    const cta = useFrontPageCta("Join Ickonic", RoutePaths.SignUp[0]);

    return <section
        id="community"
        className="front-community"
        aria-labelledby="front-community-heading"
        tabIndex={-1}
    >
        <div className="front-community__inner">
            <div className="front-community__story">
                <p className="front-community__kicker">Beyond the screen</p>
                <h2 id="front-community-heading">
                    A Community of <span>Independent Thinkers</span>
                </h2>

                <p className="front-community__lead">
                    A story can change the way you see the world. The right
                    conversation can remind you that you&apos;re not the only one
                    seeing it. Membership opens the door to a place to share
                    what you noticed, hear another perspective and keep asking
                    together.
                </p>

                <div className="front-community__actions">
                    <ButtonPillGradient
                        text={cta.text}
                        link={cta.link}
                        className="front-community__join"
                        background="linear-gradient(225deg, rgba(187, 54, 184, 1) 0%, #b760b4 100%)"
                        backgroundHover="#b760b4"
                        color="white"
                    />
                </div>
            </div>

            <ul
                className="front-community__features"
                aria-label="Ways members can take part"
            >
                {communityFeatures.map((feature, index) => (
                    <li className="front-community__feature" key={feature.title}>
                        <span
                            className="front-community__feature-number"
                            aria-hidden="true"
                        >
                            {String(index + 1).padStart(2, "0")}
                        </span>
                        <span
                            className="front-community__feature-icon"
                            aria-hidden="true"
                        >
                            {feature.icon}
                        </span>
                        <div>
                            <h3>{feature.title}</h3>
                            <p>{feature.copy}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    </section>;
};

export default FrontCommunitySection;
